import { create } from "zustand";

import type { CardInfoInterface } from "@/app/[lang]/hotels/components/HotelSearchComponent/HotelSearchDestinationContentComponent/HotelSearchDestinationContentClass";

type State = {
  openPopupComingSoon: boolean;
  hotelListLang: number;
  isHotelResultPage: boolean;
  destinationTourist: {
    touristInLocal: CardInfoInterface[] | undefined;
    popularTourist: CardInfoInterface[] | undefined;
    lang: string;
  };
  isSearchLoading: boolean;
};

type Actions = {
  setOpenPopupComingSoon: (trigger: boolean) => void;
  setHotelListLang: (data: {
    hotelListLang: number;
    isHotelResultPage: boolean;
  }) => void;
  setDestinationTourist: (data: {
    // touristInLocal = undefined ให้ hide
    // touristInLocal = [] ขึ้น skeleton
    // touristInLocal = [{}, ...] แสดงข้อมูล
    touristInLocal: CardInfoInterface[] | undefined;
    popularTourist: CardInfoInterface[] | undefined;
    lang: string;
  }) => void;
  setIsSearchLoading: (state: boolean) => void;
};
export const useHotelStore = create<State & Actions>((set) => ({
  destinationTourist: {
    popularTourist: [],
    touristInLocal: [],
    lang: "",
  },
  openPopupComingSoon: false,
  hotelListLang: 0,
  isHotelResultPage: false,
  isSearchLoading: false,
  setOpenPopupComingSoon: (trigger: boolean) =>
    set(() => ({ openPopupComingSoon: trigger })),
  setHotelListLang: (data: {
    hotelListLang: number;
    isHotelResultPage: boolean;
  }) =>
    set(() => ({
      hotelListLang: data.hotelListLang,
      isHotelResultPage: data.isHotelResultPage,
    })),
  setDestinationTourist: (data: {
    touristInLocal: CardInfoInterface[] | undefined;
    popularTourist: CardInfoInterface[] | undefined;
    lang: string;
  }) =>
    set(() => {
      return {
        destinationTourist: data,
      };
    }),
  setIsSearchLoading: (state: boolean) =>
    set(() => ({ isSearchLoading: state })),
}));
